// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"Drawing_toolbar__2PwW5","heading":"Drawing_heading__2juEI","timer":"Drawing_timer__3mFa1","selected":"Drawing_selected__1uU3S","noShadow":"Drawing_noShadow__34OXU"};